import { Typography } from '@mui/material';
import React from 'react';

interface ReleaseNoteItemProps {
    title: string;
    link: string;
    description: string;
    handleLinkClick: (link: string) => void;
}

const ReleaseNoteItem: React.FC<ReleaseNoteItemProps> = ({ title, link, description, handleLinkClick }) => (
    <li>
        <Typography variant="subtitle1" gutterBottom fontSize={18}>
            <b>{title} : </b>
            <span
                style={{ color: '#42BCDA', cursor: 'pointer' }}
                onClick={() => handleLinkClick(link)}
            >
                {description}
            </span>
        </Typography>
    </li>
);

export default ReleaseNoteItem;
